<template>
	<div
		:id="`day-${day.idArray + 1}`"
		ref="id"
		:style="{ position: 'relative', height: widthScreen < 1024 ? '70px' : '200px' }"
	>
		<div
			:class="
				dayNow.getDate() === day.day && dayNow.getMonth() + 1 === day.monthName.id
					? 'container-day-hoy-visible'
					: 'container-day-hoy'
			"
			:style="{ height: widthScreen < 1024 ? '70px' : '200px' }"
		>
			<div
				class="day"
				:class="[
					day.monthName.id === new Date().getMonth() + 1 ? 'month-current' : '',
					day.monthSelect ? 'es-hoy' : '',
					day.idArray < 28 ? 'day-border' : 'day-border border-bottom-none',
					day.idArray === 6 ||
					day.idArray === 13 ||
					day.idArray === 20 ||
					day.idArray === 27 ||
					day.idArray === 34
						? 'border-right-none'
						: '',
					day.data.length > 2 ? 'day-scroll' : '',
					dayNow.getDate() === day.day && dayNow.getMonth() + 1 === day.monthName.id
						? 'border-bottom-none'
						: '',
					'position-relative',
				]"
				:style="{ height: widthScreen < 1024 ? '70px' : '200px' }"
			>
				<div class="container-day-extend">
					<p
						class="tournament-item-day position-relative"
						style="gap: 8px"
						:class="
							dayNow.getDate() === day.day && dayNow.getMonth() + 1 === day.monthName.id
								? 'es-hoy-extend'
								: ''
						"
						@click="$emit('date-selected', day)"
					>
						{{ day.day }}
					</p>
					<div v-for="(card, key) in day.data" :key="key" class="tournament-item-task">
						<div
							@click="$emit('selectDateByCalendar', card.date_id)"
							class="container-text position-relative"
							:style="{
								background: card.color,
							}"
						>
							<!-- d-flex flex-column-reverse  justify-content-between align-items-center gap-x-1 -->
							<div
								v-if="card.classify && card.stage_id == 4"
								class="position-absolute bg-icon-classified"
							>
								<v-icon name="fa-award" scale="1.5" class="text-warning"></v-icon>
							</div>

							<div class="text-div-responsive" v-if="widthScreen >= 1024">
								<div class="text-left text-light one">
									<span
										v-if="card.method_id == 2"
										v-b-tooltip.hover.top="`Método: Al peso/${card.weight}Kg`"
									>
										<i class="fas fa-balance-scale text-primary"></i>
									</span>
									<span
										v-if="card.type_id != 1 && card.type_id != null"
										v-b-tooltip.hover.top="`Tipo: ${card.type_name}`"
									>
										<i class="fas fa-exclamation-circle text-primary"></i>
									</span>
									<span class="font-weight-bold">
										{{
											widthScreen < 600
												? card.stage_name.substr(0, 1).toUpperCase()
												: card.stage_name
										}}
									</span>
									<br />
									<!-- <small class="d-block text-truncate" style="max-width: 8rem">
										{{ card.tournament_name }}
									</small> -->
								</div>

								<b-img
									v-b-tooltip.hover
									:title="`${card.tournament_name} ${!card.classify ? '' : '(CLASIFICADO)'}`"
									rounded="circle"
									v-bind="mainProps"
									:src="card.avatar_image_thumb"
									v-if="card.avatar_image_thumb"
								/>
								<b-img
									class="two"
									rounded=""
									v-bind="mainProps"
									src="data:image/png;base64,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"
									v-else
									style="object"
								/>
							</div>
							<p class="card-mobile text-light font-weight-bold" v-else>
								<!-- {{ widthScreen < 1024 ? card.stage_name.substr(0, 1).toUpperCase() : card.stage_name }} -->
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { tooltip } from "leaflet"
import { mapState } from "vuex"

export default {
	name: "DayCalendar",
	components: {},
	props: {
		day: {
			type: Object,
			default: () => {},
		},
		height: {
			type: Number,
			default: 70,
		},
		open: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			id: null,
			scrollY: 0,
			heightC: 30,
			dayNow: new Date(),
			winScreen: screen.width,
			openModalTask: false,
			taskView: null,
			openModalLote: false,
			titleModal: "",
			loteItem: null,
			mainProps: { width: 40, height: 40 },
		}
	},
	computed: {
		...mapState("appConfig", ["layout"]),
		widthScreen() {
			return this.$store.state.app.windowWidth
		},
	},
	methods: {
		closeModal() {
			this.taskView = null
			this.openModalTask = false
		},
	},
}
</script>

<style lang="scss">
.day {
	cursor: pointer;
	text-align: center;
	padding-top: 0.5rem;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	touch-action: auto !important;
	z-index: 1 !important;
	overflow-y: scroll;
	scrollbar-width: none !important;
	-ms-overflow-style: none !important;

	&::-webkit-scrollbar {
		width: 0 !important;
		background-color: transparent !important;
	}
	@media screen and (min-width: 600px) {
	}
	.circle-mobile {
		width: 6px !important;
		height: 6px !important;
	}
	.container-day {
		height: 38px;
		width: 38px;
		border-radius: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		p {
			transition: 0.3s all ease-in-out;
			color: #cacaca;
			padding: 0;
			margin: 0 0 2px 0;
		}
	}
	.container-day-extend {
		padding: 0 0.01rem;
		@media screen and (min-width: 600px) {
			padding: 0;
		}
		@media screen and (min-width: 1024px) {
			width: 100%;
			margin: 0 8px;
		}
		.tournament-item-day {
			margin-bottom: 0.5rem !important;
			font-size: 12.6px;
			height: 28px;
			width: 28px;
			margin-left: auto;
			margin-right: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 0;
			color: #cacaca;
			@media screen and (min-width: 600px) {
				font-size: 14px;
			}
		}
		.tournament-item-task {
			//
			background: transparent;
			border-radius: 3px;
			margin: 0 0 0.2rem 0;
			display: flex;
			flex-direction: column !important;
			align-items: center;
			justify-content: center;
			// padding: 0.3px 0.6px;
			transition: 0.3s all ease-in-out;
			//   height: 15px;
			position: relative;
			@media screen and (min-width: 900px) {
				margin: 0 0 0.3rem 0;
				// padding: 1px 2px;
				height: auto;
				flex-direction: row !important;
				margin: 0 0 0.4rem 0;
			}
			@media screen and (min-width: 1024) {
				margin: 0 0 0.8rem 0;
			}
			p {
				margin-bottom: 0;
				margin-left: 0;
				//margin-top: -.15rem;
				color: #6e6b7b;
				// width: 24px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 14px;

				@media screen and (min-width: 400px) {
					padding: 0.5px 1px;
				}
				@media screen and (min-width: 600px) {
					text-align: left;
					font-size: 14px;
				}
				@media screen and (min-width: 800px) {
					margin-left: 0.2rem;
				}
				@media screen and (min-width: 768px) {
					text-align: left;
				}
				@media screen and (min-width: 900px) {
					padding: 1px 3px;
					text-align: left;
				}
				@media screen and (min-width: 1300px) {
					padding: 2px 4px;
					text-align: left;
					font-size: 14px;
				}
				@media screen and (min-width: 1600px) {
					padding: 2px 4px;
					text-align: left;
					font-size: 14px;
				}
				span {
					font-weight: bold;
				}
			}
			.final {
				position: absolute;
				top: -9px;
				right: -8px;
				height: 20px;
				width: 20px;
				color: #efb100;
				img {
					height: 12px;
					width: 12px;
					object-fit: cover;
					@media screen and (min-width: 900px) {
						top: -8px;
						right: -5px;
						height: 20px;
						width: 20px;
					}
				}
			}
			.container-text {
				width: 25px;
				padding: 0 0.05rem;
				border-radius: 4px;
				@media screen and (min-width: 400px) {
					padding: 0.5px 1px;
				}
				@media screen and (min-width: 900px) {
					width: 100%;
				}
				@media screen and (min-width: 1439) {
					padding: 0 0.2rem;
					width: 11rem;
				}
				.circle-day {
					display: none;
					@media screen and (min-width: 900px) {
						display: block;
					}
				}
				.text-div-responsive {
					padding: 0.5rem !important;
					display: grid;
					grid-template-columns: repeat(1, minmax(50px, 1fr));
					grid-template-rows: repeat(1);
					justify-items: center;
					align-items: center;
					@media screen and (min-width: 1024px) {
						grid-template-columns: repeat(1, minmax(40px, 1fr));
						font-size: 12px;
					}
					.one {
						@media screen and (min-width: 1024px) {
							grid-column: 1;
							grid-row: 2;
						}
					}
					.two {
						@media screen and (min-width: 1024px) {
							grid-column: 1;
							grid-row: 1;
						}
					}
					@media screen and (min-width: 1200px) {
						font-size: 14px;
					}
					@media screen and (min-width: 1500px) {
						font-size: 13.5px;
					}
					@media screen and (min-width: 1650px) {
						grid-template-columns: repeat(3, minmax(40px, 1fr));
						font-size: 14px;
					}
					.one {
						@media screen and (min-width: 1650px) {
							grid-column: 1/3;
							grid-row: 1;
							margin-right: 0.5rem;
						}
					}
					.two {
						@media screen and (min-width: 1650px) {
							grid-column: 3;
							grid-row: 1;
						}
					}
				}
			}
		}
		.more-text {
			color: #549de1;
			margin: -0.3rem 0 0 0;
			text-align: left;
			font-weight: 600;
		}
	}
	min-height: 30px;
	transition: 0.2s all ease-in-out;
}
.day-scroll {
	overflow-y: scroll;
}

.day-scroll::-webkit-scrollbar {
	width: 2px !important;
	background: #d5d1fb !important;
	@media screen and (min-width: 600px) {
		width: 4px !important;
	}
}

.day-scroll::-webkit-scrollbar-thumb {
	background: var(--primary) !important;
	border-radius: 6px !important;
}

.dark-layout .day {
	.container-day-extend,
	.container-day {
		.tournament-item-day {
			color: #5c616f;
		}
	}
}

.day-border {
	transition: 0.2s all ease-in-out;
	@media screen and (min-width: 600px) {
		border-bottom: #dadce0 0.6px solid;
		border-right: #dadce0 0.6px solid;
	}
}
.dark-layout .day-border {
	border-color: #2d3446;
}
.border-bottom-none {
	border-bottom: none !important;
}
.border-right-none {
	border-right: none !important;
}

.month-current {
	.container-day,
	.container-day-extend {
		.tournament-item-day {
			color: #0b0f19;
		}
	}
	.es-hoy-extend {
		color: #fff;
	}
}
.dark-layout .month-current {
	.container-day,
	.container-day-extend {
		.tournament-item-day {
			color: #fff;
		}
	}
}
.es-hoy {
	.container-day {
		background: #0090f0 !important;
		p {
			color: #fff !important;
			font-weight: 600 !important;
		}
	}
}
.es-hoy-extend {
	background: rgba(115, 103, 240, 0.5) !important;
	font-weight: 600 !important;
	color: #5c5c5c !important;
	height: 22px;
	width: 22px;
	border-radius: 50%;
	text-align: center;
	margin-right: auto;
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	@media screen and (min-width: 600px) {
		height: 28px;
		width: 28px;
	}
}
.bg-icon-classified {
	top: -8px;
	right: -8px;
	background: var(--dark);
	border-radius: 50%;
	padding: 2px;
	@media screen and (max-width: 1023px) {
		display: none;
	}
}
.circle-day {
	margin-left: 0.2rem;
	height: 4px;
	width: 4px;
	background: #d5d5d5;
	border-radius: 50%;
	@media screen and (min-width: 800px) {
		width: 6px !important;
		height: 6px !important;
		margin-left: 0.3rem;
	}
}
.dark-layout .circle-day {
	background: #aaaaaa;
}
.dark-layout .day {
	transition: 0.3s all ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
.text-count-posturas {
	margin: 0 0.2rem;
}
.container-btn-view-lote {
	button {
		width: 100px;
	}
}
.container-day-hoy-visible {
	position: absolute;
	width: 100%;
	height: 100%;
	border: 2px solid var(--primary) !important;
	background: #f3ecfe;
}

.card-mobile {
	height: 3px;
}
</style>
